import { useState, useEffect } from "react";
import Hero from "./Hero.tsx";
import TestSetting from "./TestSetting.tsx";
import wordsprintwhite from "../pics/wordsprintwhite.png";
import KeyBoard, { Sponsor } from "./Keyboard.jsx";
import FreeHand from "./FreeHand.jsx";

const Home = () => {
  const [showTopBar, setShowTopBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowTopBar(true);
      } else {
        setShowTopBar(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return <>
    <div className="scrollbar-small overflow-x-hidden bg-white dark:bg-black font-jarkarta">
      <div className="min-h-screen w-full relative items-center">
        
        {/* Top bar (only visible after scroll) */}
        {showTopBar && (
          <div className="fixed top-0 left-0 w-full z-50 bg-gray-950 px-3 py-1 shadow-md transition-all duration-300">
            <div className="flex justify-between items-center">
              {/* Left Logo */}
              <div className="flex items-center gap-1">
                <img src={wordsprintwhite} className="w-2 h-4" alt="favicon" />
                <span className="text-gray-50 text-xs tracking-wider font-dmserif">Word Sprint</span>
              </div>

              {/* Right Sponsor Button */}
              <a
                href="https://buymeacoffee.com/shafishaik"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 px-2 py-1 text-xs font-medium rounded bg-yellow-500 hover:bg-yellow-600 text-gray-950 transition"
              >
                <i className="ri-cup-line"></i>
                Sponsor
              </a>
            </div>
          </div>
        )}


        <div className="relative z-10 min-h-screen items-center">
          <div className="flex pt-3 pb-8 justify-between items-center px-3">
            <AppIcon />
            <Sponsor />
            {/* <DarkModeToggle /> */}
          </div>

          <div className="relative">

            {/* Foreground content */}
            <div className="relative z-10 flex flex-col items-center">
              <Hero />
              <TestSetting />
            </div>

            {/* Overlay keyboard (decoration, visible even on mobile) */}
            <div className="absolute top-1/4 right-[-40px] w-[200px] sm:w-[300px] md:w-[400px] lg:w-[500px] opacity-20 dark:opacity-10 -z-10 scale-150">
              <KeyBoard />
            </div>

                        {/* Right Sponsor Button + Message */}
            <div className="flex flex-col items-center">
              <span className="mt-12 flex flex-row flex-wrap gap-1 justify-center text-sm sm:text-sm md:text-sm text-gray-950 italic">
                This website runs free — donate if you’d like 
                <a
                  href="https://buymeacoffee.com/shafishaik"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 px-2 py-1 text-xs font-medium rounded bg-yellow-500 hover:bg-yellow-600 text-gray-950 transition"
                >
                  <i className="ri-cup-line"></i>
                  Sponsor
                </a>
              </span>
            </div>

          </div>
        </div>
      </div>
      
      <div className="relative h-[60vh] w-full bg-white">
        <div className="absolute inset-0 z-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]"></div>
        <div className="relative z-10">
          <FreeHand />
        </div>
      </div>


      <div className="m-h-[60vh] w-full bg-black">
        <ContactForm />
      </div>
      
    </div>
  </>
}

export const AppIcon = () => {
  return <div className="flex items-center gap-2 py-2 px-4 rounded-full font-mulish text-sm hover:shadow-lg bg-gray-950 transition">
    <img src={wordsprintwhite} className="w-2 h-4" alt="favicon" />
    <span className="text-gray-50 tracking-wider font-dmserif">Word Sprint</span>
  </div>
}

function ContactForm() {
  return (
    <div className="mx-auto max-w-6xl p-5">
      <div className="mb-5 text-5xl font-dmserif text-gray-50">Feedback</div>

      <form action="https://formsubmit.co/shaikshafieluru@gmail.com" method="POST" className="space-y-4">
        {/* Name */}
        <div className="flex flex-col">
          <label className="mb-1 font-dmserif text-gray-50">Your Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter Name .."
            required
            spellCheck={false}
            className="text-sm py-2 px-3 rounded-md border border-gray-700 bg-gray-950 text-gray-100 placeholder:text-gray-400 placeholder:font-normal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 transition"
          />
        </div>

        {/* Email */}
        <div className="flex flex-col">
          <label className="mb-1 font-dmserif text-gray-50">Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter email .."
            required
            spellCheck={false}
            className="text-sm py-2 px-3 rounded-md border border-gray-700 bg-gray-950 text-gray-100 placeholder:text-gray-400 placeholder:font-normal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 transition"
          />
        </div>

        {/* Message */}
        <div className="flex flex-col">
          <label className="mb-1 font-dmserif text-gray-50">Message</label>
          <textarea
            name="message"
            placeholder="Enter message here .."
            required
            spellCheck={false}
            className="text-sm py-2 px-3 min-h-[120px] rounded-md border border-gray-700 bg-gray-950 text-gray-100 placeholder:text-gray-400 placeholder:font-normal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 transition"
          />
        </div>

        {/* Hidden fields (optional) */}
        <input type="hidden" name="_subject" value="Word Sprint Feedback" />
        {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

        {/* Submit button */}
        <button
          type="submit"
          className="mt-2 w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition"
        >
          Send
        </button>
      </form>
    </div>

  );
}

export default Home;